<mat-icon
  class="error-icon"
  svgIcon="error-icon"
  (click)="openDialog($event)"></mat-icon>
